import { CustomTooltip } from "@shared/components/CustomTooltip";
import { Badge } from "@shared/ui/badge";
import { Button } from "@shared/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@shared/ui/card";
import React from "react";

export const WorkOrderMaintenance: React.FC<{ data: any }> = ({ data }) => {
  const getBadgeVariant = (priority: string) => {
    switch (priority) {
      case "High":
        return "destructive";
      case "Medium":
        return "secondary";
      case "Low":
        return "default";
      default:
        return "default";
    }
  };

  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
      <Card>
        <CardHeader>
          <div className="flex items-center gap-2">
            <CardTitle className="text-lg flex items-center gap-2">
              Active Work Orders
            </CardTitle>
            <CustomTooltip
              message={
                "A list of all currently open work orders directly related to this system, including their status and assigned personnel."
              }
            />
          </div>
        </CardHeader>
        <CardContent>
          {data?.workOrdersData && data.workOrdersData.length > 0 ? (
            data.workOrdersData.map((wo) => (
              <div
                key={wo.id}
                className="flex items-center justify-between p-3 bg-gray-50 rounded mt-3"
              >
                <div>
                  <p className="font-medium">{wo.description || "N/A"}</p>
                  <p className="text-sm text-gray-600">
                    {wo.id || "N/A"} • Assigned to:{" "}
                    {wo.assignee || "Unassigned"}
                  </p>
                </div>
                <div className="flex items-center gap-2">
                  <Badge variant={getBadgeVariant(wo.priority)}>
                    {wo.priority || "N/A"}
                  </Badge>
                  <Button size="sm" variant="outline">
                    View
                  </Button>
                </div>
              </div>
            ))
          ) : (
            <p className=" text-center text-gray-500 mt-3">
              No work orders found.
            </p>
          )}
        </CardContent>
      </Card>

      <Card>
        <CardHeader>
          <div className="flex items-center gap-2">
            <CardTitle className="text-lg flex items-center gap-2">
              Frequent Failure Assets
            </CardTitle>
            <CustomTooltip
              message={
                "Assets within this system that have experienced multiple breakdowns or operational failures over a defined period, indicating chronic issues."
              }
            />
          </div>
        </CardHeader>
        <CardContent>
          {data?.frequentFailureAssets &&
          data.frequentFailureAssets.length > 0 ? (
            data.frequentFailureAssets.map((asset) => (
              <div
                key={asset.id}
                className="flex items-center justify-between p-3 bg-gray-50 rounded mt-3"
              >
                <div>
                  <p className="font-medium">{asset.name || "N/A"}</p>
                  <p className="text-sm text-gray-600">
                    {asset.id || "N/A"} • {asset.failures ?? 0} failures
                  </p>
                  <p className="text-xs text-gray-500">
                    Last: {asset.lastFailure || "N/A"}
                  </p>
                </div>
                <div className="flex gap-1">
                  <Button size="sm" variant="outline">
                    View
                  </Button>
                </div>
              </div>
            ))
          ) : (
            <p className="text-center text-gray-500 mt-3">
              No frequent failure assets found.
            </p>
          )}
        </CardContent>
      </Card>
    </div>
  );
};
